"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSymbol = exports.isOneOf = exports.isInteger = exports.isInstanceOf = exports.vuePropValidator = void 0;

var vue_1 = __importDefault(require("vue"));
/**
 * Creates a Vue prop validator that runs all type validators and the user validator (if specified).
 * @param userValidator Validator function specified by the user.
 * @param typeValidators Validator functions hard-coded by the prop type function.
 */


function vuePropValidator(userValidator) {
  for (var _len = arguments.length, typeValidators = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    typeValidators[_key - 1] = arguments[_key];
  }

  var validators = userValidator ? [].concat(typeValidators, [userValidator]) : typeValidators;

  if (validators.length === 0) {
    return undefined;
  }

  return function (value) {
    var _iterator = _createForOfIteratorHelper(validators),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var validator = _step.value;
        var errorMessage = validator(value);

        if (errorMessage) {
          if (_typeof(vue_1.default) === 'object' && 'util' in vue_1.default) {
            // @ts-expect-error -- Vue.util is only available in Vue 2, but provides more context than console.warn
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
            vue_1.default.util.warn("".concat(errorMessage, " (received: '").concat(String(value), "')"));
          } else {
            console.warn("".concat(errorMessage, " (received: '").concat(String(value), "')"));
          }

          return false;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return true;
  };
}

exports.vuePropValidator = vuePropValidator; // for internal use only

var isInstanceOf_1 = require("./isInstanceOf");

Object.defineProperty(exports, "isInstanceOf", {
  enumerable: true,
  get: function get() {
    return isInstanceOf_1.isInstanceOf;
  }
});

var isInteger_1 = require("./isInteger");

Object.defineProperty(exports, "isInteger", {
  enumerable: true,
  get: function get() {
    return isInteger_1.isInteger;
  }
});

var isOneOf_1 = require("./isOneOf");

Object.defineProperty(exports, "isOneOf", {
  enumerable: true,
  get: function get() {
    return isOneOf_1.isOneOf;
  }
});

var isSymbol_1 = require("./isSymbol");

Object.defineProperty(exports, "isSymbol", {
  enumerable: true,
  get: function get() {
    return isSymbol_1.isSymbol;
  }
}); // custom validators provided for user convenience are exported from main entrypoint